var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M3.16795 0.342721C3.56377 -0.11424 4.43623 -0.11424 4.83205 0.342721L8 4H0L3.16795 0.342721Z",
    fill: "#033D8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon1);
export default __webpack_public_path__ + "static/media/polygon-1.0b1e3e1ab00722aef05e9de9bf65cb18.svg";
export { ForwardRef as ReactComponent };